import { useContext } from "react";
import { ButtonStyled } from "../../../style/button";
import { StyledText } from "../../../style/typography";
import { CartContext } from "../../../providers/CartContext";
import { CartTotalStyled } from "./style";

export const CartTotal = () => {
  const { setCart, cartTotal } = useContext(CartContext);
  return (
    <CartTotalStyled>
      <div>
        <StyledText tag="body-600" weigth={600} color="black">
          Total
        </StyledText>
        <StyledText tag="body-600" weigth={600} color="#828282">
          R$ {cartTotal.toFixed(2)}
        </StyledText>
      </div>
      <ButtonStyled
        onClick={() => {
          setCart([]);
        }}
        buttonStyle="secondaryMedium"
      >
        Remover todos
      </ButtonStyled>
    </CartTotalStyled>
  );
};
